import React from 'react';
import { string, object, oneOf } from 'prop-types';
import classNames from 'classnames';

export default function Panel({ children, className, style, type }) {
  const css = classNames('Panel bg-page rounded border-t-4 shadow-sm', className, {
    'border-primary': type === 'primary',
    'border-neutral': type === 'secondary',
  });
  return (
    <div
      className={css}
      style={style}
    >
      <div className="bg-dropdown px-4 py-6">
        {children}
      </div>
    </div>
  );
}

Panel.propTypes = {
  type: oneOf(['primary', 'secondary']),
  className: string,
  style: object,
};

Panel.defaultProps = {
  type: 'secondary',
};
